<template>
    <div class="page" v-if="detail.name != ''">
        <div>
            <div class="music">
                <div class="cover">
                    <img :src="detail.cover" class="cover-img" />
                </div>
            </div>
            <div class="table"><!--{{isFixedTop?'fixed':''}}-->
                <div :class="type=='XiangQing'?'tab-li curr':'tab-li'" @click="bindType" data-type="XiangQing">详情</div>
                <div :class="type=='MuLv'?'tab-li curr':'tab-li'" @click="bindType" data-type="MuLv">目录</div>
            </div>
            <div class="table-content">
                <div class="table-content-xiangqing" v-if="type=='XiangQing'">
                    <div v-html="detail.content"></div>
                </div>
                <div class="table-content-MuLv" v-if="type=='MuLv'">
                    <div class="pub-title">
                        <div class="calendar-tips">
                            <div class="calendar-tips-li">
                                <span class="tips-li-chart tips-ok"></span>
                                <span class="tips-li-txt">已完成</span>
                            </div>
                            <div class="calendar-tips-li">
                                <span class="tips-li-chart tips-in-study"></span>
                                <span class="tips-li-txt">学习中</span>
                            </div>
                            <div class="calendar-tips-li">
                                <span class="tips-li-chart tips-stay-study"></span>
                                <span class="tips-li-txt">待学习</span>
                            </div>
                            <div class="calendar-tips-li">
                                <span class="tips-li-chart tips-stay-class"></span>
                                <span class="tips-li-txt">待上课</span>
                            </div>
                        </div>
                    </div>

                    <date :list="date_params[month]" :curr_year="curr_year" :curr_month="curr_month" v-on:datetap="getDateInfo" v-on:lastMonth="lastMonth" v-on:nextMonth="nextMonth"></date>

                    <div class="pub-list" v-if="!is_show">
                        <van-index-bar class="pub-item" v-for="(item,index) in params[month]" :key="index" :index-list="[]">
                            <div class="pub-item-title" :id="'date'+index">
                                <div class="item-title-week"><span v-if="!item.end_date">周{{item.week}}</span></div>
                                <div class="item-title-date">{{item.start_date}}{{item.end_date?' ~ '+item.end_date:''}}</div>
                            </div>
                            <div class="pub-item-content">
                                <div class="time-table-title" v-for="(items,indexs) in item.course_item" :key="indexs" :data-id="items.course_id" @click="bindMore">
                                    <div class="table-title-text">
                                        <div class="title-text">
                                            {{items.name}}
                                        </div>
                                        <div class="title-text-time">
                                            上课时间：{{items.start_time}}-{{items.end_time}}
                                        </div>
                                        <div class="title-text-time">
                                            老师/讲师：{{items.lecturer}}
                                        </div>
                                        <div class="title-text-appointment">
                                            <span class="iconfont iconchakan"></span> {{items.view_count}} 次观看
                                            <span class="text-appointment-type" v-if="detail.is_apply == 0">需预约</span>
                                        </div>
                                    </div>
                                    <div class="table-title-img">
                                        <img class="title-img" :src="items.cover" />
                                    </div>
                                </div>
                            </div>
                        </van-index-bar>
                    </div>
                    <div class="pub-no" v-if="is_show">没有更多的数据啦~</div>
                </div>
            </div>
        </div>

        <div class="make-an-appointment">
            <div class="share"><span class="iconfont iconfenxiang"></span></div>
            <div class="trial-class" style="display:none">试课</div>

            <div class="make-an-appointment-text" v-if="detail.is_apply == 0" @click="bindApply">立即预约</div>
            <div class="make-an-appointment-text" style="background-color:#00CC00" v-if="detail.is_apply == 1">已预约</div>
        </div>
    </div>
</template>

<script>
    import date from '../../components/common/date';
    import {Dialog,IndexBar, IndexAnchor} from 'vant';
    export default {
        name: "index",
        components:{
            date,
            [IndexBar.name]:IndexBar,
            [IndexAnchor.name]:IndexAnchor
        },
        data(){
            return {
                type:'XiangQing',
                date_into_view:'',
                month:'',
                curr_year:'',
                curr_month:'',
                scheduling_id:'',
                p_id:'',
                params:{},
                date_params:{},
                detail:{
                    name:''
                },
                is_show:false,
            }
        },
        mounted() {
            this.scheduling_id = this.util.getQueryStr('scheduling_id');
            //浏览量+1
            this.util.server.event.event({
                data: {
                    message:{scheduling_id:this.scheduling_id,source:'h5'},
                    code:10000,
                },
                callback: (res => {})
            });
            this.getSchedulingDetail();
            this.bindWeiXin();
        },
        methods:{
            bindWeiXin:function(){
                var _self=this;
                var link = location.href;
                if(location.href.indexOf('&scheduling_id=') == -1){
                    link = link + '&scheduling_id='+_self.scheduling_id
                }else{
                    link = 'https://'+location.host+this.util.urlPrefix+'/time_table_detail/index?course_id='+this.course_id+'&token='+this.util.token+'&scheduling_id='+this.scheduling_id
                }
                this.util.jweixin(function (wx) {
                    var _that=_self;
                    _self.util.wxShare(wx, {
                        title: _that.detail.name,
                        desc: _that.detail.name,
                        link: link,
                        imgUrl: _that.detail.cover
                    });
                });
            },
            //详情
            getSchedulingDetail:function(){
                var _self=this;
                this.util.server.mini_scheduling.detail({
                    data: {
                        scheduling_id:this.scheduling_id
                    },
                    callback: (res => {
                        var data= res.data;

                        _self.$(document).attr('title',data.name);

                        _self.util.tansPics(data, 'cover', {
                            default_img: '',
                            style: 'w375'
                        });

                        if (data.content) {
                            data.content = data.content.replace(/<img/gi,'<img style="max-width:100%;height:auto"');
                        }

                        _self.detail = data;
                        _self.month = data.curr_month;
                        _self.curr_year = data.curr_month.split('-')[0]*1;
                        _self.curr_month = data.curr_month.split('-')[1]*1-1;
                    })
                });
            },
            bindApply(){
                var _self=this;
                Dialog.confirm({
                    title: '提示',
                    message: '确定预约该课表？',
                }).then(() => {
                    // on confirm
                    // this.util.carouselUrl('pages/user/login');
                    _self.util.server.mini_scheduling.apply({
                        data:{
                            scheduling_id:_self.scheduling_id
                        },
                        callback:(res=>{
                            if(res.code == 1){
                                _self.util.showToast({
                                    message: '预约成功'
                                });
                                _self.detail.is_apply = 1;
                            }
                        })
                    })
                }).catch(() => {
                    // on cancel
                });
            },
            bindType:function(e){
                var type=e.currentTarget.dataset.type;
                this.bindSwitch(type);
            },
            bindSwitch:function(type){
                this.type = type;
                switch (type) {
                    case 'MuLv':
                        this.getSchedulingCalendar();
                        break;
                }
            },
            //课表日期
            getSchedulingCalendar:function(){
                var _self=this;

                if(this.date_params[this.month]){
                    return _self.getSchedulingList();
                }

                this.util.server.mini_scheduling.calendar({
                    data:{
                        scheduling_id:this.scheduling_id,
                        month:this.month,
                    },
                    callback: (res => {

                        this.date_params[this.month] =res.data;
                        this.$set(this.date_params, this.month, res.data);
                        this.$forceUpdate();

                        _self.getSchedulingList();
                    })
                })
            },

            //列表
            getSchedulingList:function(){
                var _self=this;

                if(this.params[this.month]){

                    _self.is_show=false;

                    if(this.params[this.month].length==0){
                        _self.is_show=true;
                    }

                    return;
                }

                this.util.server.mini_scheduling.list({
                    data:{
                        scheduling_id:this.scheduling_id,
                        month:this.month,
                    },
                    callback: (res => {
                        this.$set(this.params, this.month, res.data);
                        this.$forceUpdate();
                        this.is_show = false;

                        if(res.data.length==0){
                            this.is_show=true
                        }
                    })
                })
            },
            //当天信息
            getDateInfo:function(e){
                this.date_into_view = 'date'+e.year+'-'+e.month+'-'+e.day;
                if(this.params[this.month][e.year+'-'+e.month+'-'+e.day]){
                    document.getElementById(this.date_into_view).scrollIntoView({
                        behavior: "smooth",  // 平滑过渡
                        block: "start"  // 上边框与视窗顶部平齐。默认值
                    });
                }
            },
            //上个月
            lastMonth:function(e){
                var date=e.year+'-'+e.month;
                this.month = date;
                this.curr_year = date.split('-')[0]*1;
                this.curr_month = date.split('-')[1]*1-1;
                this.bindSwitch(this.type);
            },
            //下个月
            nextMonth:function(e){
                var date=e.year+'-'+e.month;
                this.month = date;
                this.curr_year = date.split('-')[0]*1;
                this.curr_month = date.split('-')[1]*1-1;
                this.bindSwitch(this.type);
            },
            //跳转课程
            bindMore:function(e){

                if(this.detail.is_apply == 0){
                    this.bindApply();
                    return
                }

                var id=e.currentTarget.dataset.id;
                this.$router.push(this.util.gotoCurriculumDetailUrl(6,id));
            },
        }
    }
</script>

<style scoped>
    div{
        color: #3a3a3a;
    }
    .cover-img{
        width: 100%;
    }
    .page{
        background-color: #ffffff;
    }
    .scroll{
        height: 100vh;
        overflow: hidden;
    }
    .music{
        /*height: 100%;*/
        width: 100%;
        background-color: #fff;
    }
    .cover{
        width: 100%;
        margin: 0 auto;
        text-align: center;
        position: relative;
        font-size: 0;
    }
    .cover image{
        width: 100%;
    }
    .table{
        display: table;
        width: 100%;
        overflow: hidden;
        border-bottom: 1px solid #ddd;
    }
    .table.fixed{
        position: fixed;
        top:0;
        z-index:1;
        margin-top: 0px;
    }
    .table .tab-li{
        background-color: #fff;
        display: table-cell;
        font-size: 16px;
        min-width: 74px;
        padding: 0 5px;
        height: 40px;
        text-align: center;
        vertical-align: middle;
        position: relative;
    }
    .table .tab-li.curr{
        color: #FF6600;
        font-weight: bold;
    }
    .table .tab-li.curr:after {
        position: absolute;
        content: "";
        bottom: 0;
        width: 42px;
        height: 3px;
        background-color: #FF6600;
        opacity: 1;
        border-radius: 4px;
        left: 50%;
        margin-left: -21px;
    }
    .table-content{
        width: 100%;
        /*height: 100%;*/
        background-color: #fff;
    }
    .table-content-xiangqing{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 10px;
        box-sizing: border-box;
    }
    .pub-list{
        overflow:hidden;
        width: 100%;
    }
    .pub-no{
        text-align: center;
        font-size: 16px;
        margin: 20px 0;
        margin-bottom: 61px;
    }
    .time_table_name{
        font-size: 12px;
        font-weight: bold;
    }
    .pub-title{
        position: relative;
        padding: 10px;
        box-sizing: border-box;
    }
    .calendar-tips{
        text-align: right;
    }
    .calendar-tips-li{
        display: inline-block;
        font-size: 12px;
    }
    .tips-li-chart{
        width: 16px;
        height: 16px;
        display: inline-block;
        vertical-align: middle;
        border-radius: 15px;
        margin: 0 5px;
    }
    .tips-ok{
        background-color: #35d0ba;
    }
    .tips-in-study{
        background-color: #ffcd3c;
    }
    .tips-stay-study{
        background-color:#ff9234;
    }
    .tips-stay-class{
        background-color: #d92027;
    }
    .tips-li-txt{
        display: inline-block;
        vertical-align: middle;
    }
    .pub-list .pub-item:last-child{
        margin-bottom: 51px;
    }
    .pub-item .pub-item-title{
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        padding: 10px;
    }
    .pub-item-title .item-title-week{
        font-size: 12px;
        font-weight: bold;
        display: inline-block;
    }
    .pub-item-title .item-title-date{
        font-size: 12px;
        float: right;
    }
    .pub-item .pub-item-content{
        box-sizing: border-box;
    }
    .time-table-title{
        position: relative;
        margin: 10px;
        height:100px;
    }
    .table-title-text{
        padding-left: 150px;
        height: 100px;
    }
    .title-text{
        font-size: 12px;
        font-weight: bold;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        height: 32px;
    }
    .title-text-time{
        font-size: 12px;
        margin-top: 5px;
    }
    .title-text-appointment{
        font-size: 12px;
        position: relative;
        margin-top: 7px;
    }
    .text-appointment-type{
        position: absolute;
        right: 0;
        color: #f30;
    }
    .title-text-appointment .iconfont{
        font-size: 12px;
    }
    .table-title-img{
        position: absolute;
        left: 0;
        top: 0;
        font-size: 0;
        height: 100px;
    }
    .title-img{
        width: 145px;
        height: 100%;
    }
    .make-an-appointment{
        position: fixed;
        bottom: 0;
        width: 100%;
        border: 1px solid #ccc;
        background-color: #fff;
        display: flex;
    }
    .share{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 0 15px;
        line-height: 39px;
        background-color: #fff;
        border-radius:0;
    }
    .share::after{
        content: '';
        width: 0;
        height: 0;
    }
    .trial-class{
        text-align: center;
        display: inline-block;
        border-right: 1px solid #ccc;
        padding: 10px 20px;
    }
    .make-an-appointment-text{
        display: inline-block;
        text-align: center;
        background-color: #FF6600;
        color: #fff;
        border-right: 1px solid #ccc;
        padding: 10px;
        flex: 1;
    }
</style>
